import { h } from '@stencil/core';
import { ETabType, scrollToComponent, store, setLinearProductData, ACTION_TYPES, tryParse } from '@pes-ui/utils';
import { isBrowser, isMobile } from '../../../globals/utils';
import { observeIntersectionWithHeader, setStickyBarTab, setTabActive, } from '../../../globals/stickyBar.utils';
export class ExtendedProductDataSheet {
  constructor() {
    this.elements = {};
    this.breakpointListener = () => {
      this.isMobile = !this.mql.matches;
    };
    this.collectRefAndTitle = (title) => (ref) => {
      this.elements[title] = ref;
    };
    this.epds = undefined;
    this._epds = undefined;
    this.isMobile = isMobile();
  }
  setupResizeListeners() {
    this.mql = window.matchMedia('(min-width: 980px)');
    this.isMobile = !this.mql.matches;
    if (isBrowser()) {
      this.mql.addEventListener('change', this.breakpointListener);
    }
  }
  setStickyBarTabs() {
    var _a;
    const titles = (_a = this.epds) === null || _a === void 0 ? void 0 : _a.map(({ title }) => title);
    if (!(titles === null || titles === void 0 ? void 0 : titles.length))
      return;
    setStickyBarTab(ETabType.EPDS, titles);
  }
  componentWillLoad() {
    var _a;
    this.epds = (_a = tryParse(this._epds)) !== null && _a !== void 0 ? _a : this.epds;
    store.dispatch(setLinearProductData({ epds: this.epds }));
    this.unsubscribe = store.subscribe(() => {
      var _a;
      const { data, activeProductTab, lastActionType } = store.getState().product;
      if (lastActionType !== ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB)
        return;
      const activeEpds = ((_a = data[activeProductTab]) === null || _a === void 0 ? void 0 : _a.epds) || null;
      if (this.epds !== activeEpds) {
        this.epds = activeEpds;
      }
      this.setStickyBarTabs();
    });
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
    (_b = this.mql) === null || _b === void 0 ? void 0 : _b.removeEventListener('change', this.breakpointListener);
  }
  handleTabClicked(event) {
    const el = this.elements[event.detail.title];
    if (!el)
      return;
    scrollToComponent(el);
  }
  observe() {
    Object.entries(this.elements).forEach((epdsElement) => {
      const [title, ref] = epdsElement;
      observeIntersectionWithHeader(ref, (entries) => {
        var _a;
        if (!((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting))
          return;
        setTabActive({ type: ETabType.EPDS, title });
        this.setTabActive.emit();
      });
    });
  }
  componentDidLoad() {
    if (!this.epds)
      return;
    this.setStickyBarTabs();
    this.setupResizeListeners();
    this.observe();
  }
  renderItem(item) {
    if (this.isMobile) {
      return (h("pes-collapsible-container", { class: "epds__collapsible-container" }, item.title && (h("pes-section-header", { slot: "header", class: "epds__heading" }, item.title)), item.content && item.content.map((content) => h("div", { innerHTML: content }))));
    }
    return (h("pes-section-with-header", { headingLabel: item.title || '', withColumns: true }, item.content && item.content.map((content) => h("div", { innerHTML: content }))));
  }
  render() {
    if (!this.epds)
      return null;
    return (h("div", { class: "epds" }, this.epds.map((item) => (h("div", { ref: this.collectRefAndTitle(item.title) }, this.renderItem(item))))));
  }
  static get is() { return "pes-epds"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-epds.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-epds.css"]
    };
  }
  static get properties() {
    return {
      "epds": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TEpdsItem[]",
          "resolved": "TEpdsItem[]",
          "references": {
            "TEpdsItem": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "_epds": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-epds",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "isMobile": {}
    };
  }
  static get events() {
    return [{
        "method": "setTabActive",
        "name": "setTabActive",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "tabClicked",
        "method": "handleTabClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
